<template>
    <v-system-bar app height="36px" class="justify-center px-1 darktext--text font-weight-bold"
    :class="mobile() ? 'text-caption' : 'text-body-2'" color="yellowlight">
        <p class="d-block my-0" :style="mobile() ? 'line-height:1' : ''">{{ $t('cancelSubscriptionMsg')  }} {{format_date(subscriptionEnds)}}.
        <a
            color="accent"
            class="text-decoration-underline"
            @click="getStripePortal()"
        >
            {{ $t("renew")  }} 
        </a>&nbsp;{{ $t('cancelSubscriptionMsg2') }}</p>
    </v-system-bar>
</template>
<script>
import { getStripePortal } from '../api/spaceApi'
import moment from "moment";
import { repeatedMethodsMixin } from '../mixins/repeatedMethodsMixin'
export default {
   mixins: [repeatedMethodsMixin],
     data: function() {
    return { 
      spaceId: window.$cookies.get('space_id'),
      subscriptionEnds: localStorage.space
        ? JSON.parse(localStorage.space).subscription_ends_at
        : null,
    }
  },
  methods: {
        format_date(value) {
      if (value) {
        return moment(String(value)).format("DD MMM YYYY");
      }
    },
    async getStripePortal() {
        try {
          const response = await getStripePortal(this.spaceId);
          if (response.status) {
            if (response.status == 200) {
              window.location.href = response.data.meta.stripe_portal_url
            }
          }
        } catch (e) {
          if (e.response) {
            if (e.response.status == 403) {
              this.$router.push({ name: "PageAccessDenied" });
            } else {
              this.$emit('proceedError')
            }
          }
        }
      
     }, 
  },
}
</script>

